import React, { useState } from "react";
import api, { apiError } from "@/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { Label } from "@/components/ui/label";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

export function ChangePasswordDialog({ open, onOpenChange }) {
  const { user } = useAuth();
  const hasPassword = user?.login_method !== "google";
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (form.new_password.length < 6) return toast.error("Password baru minimal 6 karakter");
    if (form.new_password !== form.confirm) return toast.error("Konfirmasi password tidak sama");
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current_password || null, new_password: form.new_password });
      toast.success(hasPassword ? "Password berhasil diubah" : "Password berhasil dibuat — sekarang bisa login dengan email & password");
      setForm({ current_password: "", new_password: "", confirm: "" });
      onOpenChange(false);
    } catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><KeyRound className="w-4 h-4" /> {hasPassword ? "Ubah Password" : "Buat Password"}</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <p className="text-xs text-slate-500">Akun: <span className="font-mono">{user?.email}</span></p>
          {hasPassword && <div><Label>Password Saat Ini</Label><PasswordInput data-testid="pw-current" autoComplete="current-password" value={form.current_password} onChange={(e) => setForm({ ...form, current_password: e.target.value })} /></div>}
          {!hasPassword && <p className="text-xs text-amber-700 bg-amber-50 border border-amber-200 rounded px-2 py-1.5">Akun ini masuk via Google. Buat password agar bisa juga login dengan email & password.</p>}
          <div><Label>Password Baru</Label><PasswordInput data-testid="pw-new" autoComplete="new-password" value={form.new_password} onChange={(e) => setForm({ ...form, new_password: e.target.value })} placeholder="Minimal 6 karakter" /></div>
          <div><Label>Konfirmasi Password Baru</Label><PasswordInput data-testid="pw-confirm" autoComplete="new-password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} onKeyDown={(e) => e.key === "Enter" && save()} /></div>
        </div>
        <DialogFooter><Button data-testid="pw-save" onClick={save} disabled={saving} className="bg-slate-900 hover:bg-slate-800">{saving ? "Menyimpan..." : "Simpan"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
